/*
    BusOpsTimePointsListing is the shell for displaying the
    TimepointPaging component (defined beneath this class)

    There will be a set of column headers rendered here,
    and there are media queries for different screen sizes
*/

import React from "react";
import Media from "react-media";

import MainContext from "../MainContext";

import BusOpsTimePoint from "../DataDisplay/BusOpsTimePoint";

import DataItem from "../Components/DataItem";

import { getTimePoints } from "../Requests/BusOpsRequests";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";

export default class BusOpsTimePointsListing extends React.Component {

    static contextType = MainContext;

    state = {
        timepoints: []
    }

    componentDidMount() {
        const request = () => getTimePoints(this.props.data);
        const then = ({data}) => {
            this.setState({timepoints: data});
        };
        this.context.runProcessing(request, then, "getTimePoints");
    }

    render(){

        const {data} = this.props;

        // use the manual delay if there's a value set
        const delayVal = data.ManualDelay || data.SecLate;
        const realtimeDelay = `${delayVal >= 0 ? "+": ""}${Math.round(delayVal/60)}M `;

        return (
            <div>
                <Media query="(max-width: 811px)">
                    <>
                    <div style={{
                        margin: "8px 0 16px"
                    }}>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 2fr"
                        }}>
                            <div className="form-element-horizontal">
                                <label>Route</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <><div>({data.switched.tripFrom.route})</div>&nbsp;</>
                                        : null
                                    }
                                    <DataItem val={data.Route} />
                                </div>
                            </div>
                            <div className="form-element-horizontal">
                                <label>Run</label>
                                <DataItem val={data.Run} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "1fr 3fr"}}>
                                <label>Dest</label>
                                <DataItem val={data.Header} />
                            </div>
                        </div>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr"}}>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "3fr 1fr"}}>
                                <label>Realtime Delay</label>
                                <DataItem val={realtimeDelay} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "2fr 3fr"}}>
                                <label>Scheduled<br />Departure</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <div>({data.switched.tripFrom.departure})</div>
                                        : null
                                    }
                                    <DataItem val={data.SchedDepTime} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <TimepointPaging timepoints={this.state.timepoints} size={13} />
                    </>
                </Media>
                <Media query="(min-width: 812px)">
                    <>
                    <div className="departure-form-subvertical" style={{marginTop:"12px"}}>
                        <div className="form-element-horizontal">
                            <label>Route</label>
                            <div className="swap-vertical">
                                {
                                    data.switched && data.switched.tripFrom
                                    ? <><div>({data.switched.tripFrom.route})</div>&nbsp;</>
                                    : null
                                }
                                <DataItem val={data.Route} />
                            </div>
                        </div>
                        <div className="form-element-horizontal">
                            <label>Run</label>
                            <DataItem val={data.Run} />
                        </div>
                        <div className="form-element-horizontal" style={{gridTemplateColumns: "1fr 6fr"}}>
                            <label>Dest</label>
                            <DataItem val={data.Header} />
                        </div>
                        <div className="form-element-horizontal" style={{gridTemplateColumns: "2fr 5fr"}}>
                            <label>Scheduled<br />Departure</label>
                            <div className="swap-vertical">
                                {
                                    data.switched && data.switched.tripFrom
                                    ? <div>({data.switched.tripFrom.departure})</div>
                                    : null
                                }
                                <DataItem val={data.SchedDepTime} />
                            </div>
                        </div>
                        <div className="form-element-horizontal" style={{gridTemplateColumns: "3fr 1fr"}}>
                            <label>Realtime<br />Delay</label>
                            <DataItem val={data.SecLate} />
                        </div>
                    </div>
                    <TimepointPaging timepoints={this.state.timepoints} size={6} />
                    </>
                </Media>
            </div>
        )
    }
};

/*
    Displays the list of timepoints associated with a trip, 
    one page at a a time, and the interaction for 
    moving between those pages
*/

class TimepointPaging extends React.Component {

    state = {
        currentPage: 1
    }

    goForward = () => {
        this.setState({currentPage: this.state.currentPage+1});
    }

    goBackward = () => {
        this.setState({currentPage: this.state.currentPage-1});
    }

    render(){
        // determine the page size and number of pages
        const maxPage = Math.ceil(this.props.timepoints.length/this.props.size);
        const {size} = this.props;
        const {currentPage} = this.state;

        const displayPoints = this.props.timepoints.slice(size*(currentPage-1), size*currentPage);

        // be sure that we don't distort the placement of timepoints
        // on the last page
        if(displayPoints.length < size && maxPage > 1){
            // add placeholders to maintain size
            const length = displayPoints.length;
            for(let i = length; i < size; i++){
                displayPoints.push(null);
            }
        }

        return (
            <>
            <div style={{
                marginBottom: "4px",
                fontWeight: "bold",
                backgroundColor: "white",
                alignSelf: "stretch",
                textAlign: "center",
                display: "flex",
                justifyContent: "center"
            }}>
                {
                    this.state.currentPage > 1
                    ? <span className="paging" onClick={this.goBackward}><i className="fas fa-long-arrow-alt-left"></i></span>
                    : null
                }
                <span style={{margin:"auto 4px"}}>
                    STOPS
                </span>
                {
                    this.state.currentPage < maxPage
                    ? <span className="paging" onClick={this.goForward}><i className="fas fa-long-arrow-alt-right"></i></span>
                    : ""
                }
            </div>
            {
                displayPoints.map((tp, index) => {
                    if(tp !== null){
                        return <BusOpsTimePoint key={index} data={tp} />
                    }
                    else{
                        return <div key={index} className="empty-row"></div>
                    }
                })
            }
            </>
        );
    }
};